document.addEventListener('DOMContentLoaded', function () {
  class PkEstimateDeliveryDate extends HTMLElement {
    constructor() {
      super();
  
      this.pickupDeliveryTiming = parseInt(this.getAttribute("data-pickup-delivery-timing"));
      this.homeDeliveryTiming = parseInt(this.getAttribute("data-home-delivery-timing"));
      this.pickupDeliveryDate = this.querySelector("[data-date-pickup]");
      this.homeDeliveryDate = this.querySelector("[data-date-home]");
      this.dateFormat = this.getAttribute("data-date-format");
      
      this.country = 'metropole';
      this.year = new Date().getFullYear();
      this.months = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];
      this.holidays = [];
  
      this.init();
    }

    async init() {
      if (!this.pickupDeliveryTiming && !this.homeDeliveryTiming) {
        console.error('At least one of data-pickup-delivery-timing or data-home-delivery-timing attributes is required.');
        return;
      }

      await this.fetchHolidays();

      if (this.pickupDeliveryTiming) {
        this.displayPickupDeliveryDate();
      }

      if (this.homeDeliveryTiming) {
        this.displayHomeDeliveryDate();
      }
    }
  
    async fetchHolidays() {
      try {
        const response = await fetch(`https://calendrier.api.gouv.fr/jours-feries/${this.country}/${this.year}.json`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        this.holidays = Object.values(data);
      } catch (error) {
        console.error('Error fetching holidays:', error);
      }
    }
  
    addWorkingDays(date, days) {
      let counter = 0;
      while (counter < days) {
        date.setDate(date.getDate() + 1);
        if (this.isWorkingDay(date)) {
          counter++;
        }
      }
      return date;
    }
  
    isWorkingDay(date) {
      const day = date.getDay();
      const dateString = date.toISOString().split('T')[0];
      return day !== 0 && !this.holidays.includes(dateString);
    }

    formatDate(date) {
      if (this.dateFormat === "short") {
        // Format: 01/02/2025
        return date.toLocaleDateString("fr-FR");
      } else {
        // Format: samedi 1er février
        const dayNumber = date.getDate();
        const month = this.months[date.getMonth()];
        const weekday = date.toLocaleDateString("fr-FR", { weekday: "long" });

        return `${weekday} ${dayNumber} ${month}`;
      }
    }

    displayPickupDeliveryDate() {
      const today = new Date();
      const dateToDelivery = this.addWorkingDays(new Date(today), this.pickupDeliveryTiming / 24);
      this.pickupDeliveryDate.innerHTML = this.formatDate(dateToDelivery);
    }
  
    displayHomeDeliveryDate() {
      const today = new Date();
      const dateToDelivery = this.addWorkingDays(new Date(today), this.homeDeliveryTiming / 24);
      this.homeDeliveryDate.innerHTML = this.formatDate(dateToDelivery);
    }
  }
  
  customElements.define('pk-estimate-delivery-date', PkEstimateDeliveryDate);
});
